/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Pkg_Log_Toast_AdjustedInputs */

const vi_pkg_log_toast_adjusted = /** @type {(inputs: Pkg_Log_Toast_AdjustedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã tạo ${i?.n} phiếu điều chỉnh`)
};

/**

* @param {Pkg_Log_Toast_AdjustedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkg_log_toast_adjusted = /** @type {((inputs: Pkg_Log_Toast_AdjustedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkg_Log_Toast_AdjustedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkg_log_toast_adjusted(inputs)
});